import React from "react";

import LocationAccessAcknowledgementModal from "../../components/LocationAccessAcknowledgementModal/LocationAccessAcknowledgementModal";
import ddLog from "./datadog/log";

import { store as reduxStore } from "../../redux/store";
import * as elementsActions from "../../redux/actions/elements";

export const needsLocationAccessAcknowledgement = store =>
  Boolean(store?.hasLocationAccessRestriction) &&
  Boolean(store?.locationAccessMessage?.trim());

export const normalizeLocationAccessStoreId = id =>
    id == null || id === "" ? null : String(id);

export const getActiveOrderStoreIdForLocationAccess = () => {
  const state = reduxStore.getState();
  const selectedStoreId = normalizeLocationAccessStoreId(
    state.user?.selectedStore?.id
  );
  const orderStoreId = normalizeLocationAccessStoreId(state.order?.store?.id);
  return selectedStoreId ?? orderStoreId;
};

export const isStoreCurrentlyActiveForLocationAccess = storeId => {
  if (!storeId) {
    return false;
  }
  const state = reduxStore.getState();
  const selectedStoreId = normalizeLocationAccessStoreId(
    state.user?.selectedStore?.id
  );
  const orderStoreId = normalizeLocationAccessStoreId(state.order?.store?.id);
  return storeId === selectedStoreId || storeId === orderStoreId;
};

/** Skip modal only when user already acked this store for the currently active order store (Anant re-select case). */
export const shouldSkipLocationAccessAcknowledgementModal = store => {
  if (!needsLocationAccessAcknowledgement(store)) {
    return false;
  }

  const storeId = normalizeLocationAccessStoreId(store?.id);
  const acknowledgedStoreId = normalizeLocationAccessStoreId(
    reduxStore.getState().elements?.locationAccessAcknowledgedStoreId
  );

  return Boolean(
    storeId &&
      acknowledgedStoreId === storeId &&
      isStoreCurrentlyActiveForLocationAccess(storeId)
  );
};

export const runWithLocationAccessAcknowledgement = (
  store,
  setModalObject,
  onProceed
) => {
  if (!needsLocationAccessAcknowledgement(store)) {
    return onProceed();
  }

  if (shouldSkipLocationAccessAcknowledgementModal(store)) {
    return onProceed();
  }

  return new Promise(resolve => {
    const handleCancel = () => {
      setModalObject(null);
      resolve(false);
    };

    const handleContinue = async () => {
      reduxStore.dispatch(
        elementsActions.setLocationAccessAcknowledgedStoreId(
          normalizeLocationAccessStoreId(store?.id)
        )
      );
      setModalObject(null);
      try {
        const result = await onProceed();
        resolve(result);
      } catch (error) {
        ddLog.logError(error);
        resolve(false);
      }
    };
  
    setModalObject({
      children: (
        <LocationAccessAcknowledgementModal
          store={store}
          onContinue={handleContinue}
          onCancel={handleCancel}
        />
      ),
      exit: true,
      maxWidth: "min(480px, calc(100vw - 40px))",
      ariaLabelledBy: "location-access-modal-title",
      action1: handleCancel
    });
  });
};
